import { mapBrand, mapBrands } from "@/api/mapping/brands";

export default function ($api) {
    return {
        /**
         * Получение списка брендов
         * @param { String } query
         * @returns {*}
         */
        getAll(query = "") {
            return $api.get(`api/brand/all?sorts[sort]=asc` + query).then(mapBrands);
        },
        /**
         * Получение одного бренда
         * @param { String } slug
         * @returns {*}
         */
        getOne(slug) {
            return $api.get(`api/brand/one?filters[slug][eq]=${slug}`).then(mapBrand);
        },
    };
}
